import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-4 gap-4 p-4 bg-card border-b border-border">
      <div className="bg-success/5 border border-success/20 rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <Icon name="CheckCircle" size={20} className="text-success" />
          <span className="text-xs font-medium text-success">+{stats?.successRate}%</span>
        </div>
        <div className="text-2xl font-bold text-foreground">{stats?.totalAudits?.toLocaleString('de-DE')}</div>
        <div className="text-xs text-muted-foreground mt-1">Gesamt-Audit-Einträge</div>
      </div>
      <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <Icon name="Shield" size={20} className="text-primary" />
          <span className="text-xs font-medium text-primary">DSGVO</span>
        </div>
        <div className="text-2xl font-bold text-foreground">{stats?.gdprCompliant?.toLocaleString('de-DE')}</div>
        <div className="text-xs text-muted-foreground mt-1">DSGVO-konforme Einträge</div>
      </div>
      <div className="bg-warning/5 border border-warning/20 rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <Icon name="AlertTriangle" size={20} className="text-warning" />
          <span className="text-xs font-medium text-warning">Warnung</span>
        </div>
        <div className="text-2xl font-bold text-foreground">{stats?.flaggedEntries}</div>
        <div className="text-xs text-muted-foreground mt-1">Markierte Einträge</div>
      </div>
      <div className="bg-accent/5 border border-accent/20 rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <Icon name="Users" size={20} className="text-accent" />
          <span className="text-xs font-medium text-accent">Aktiv</span>
        </div>
        <div className="text-2xl font-bold text-foreground">{stats?.activeUsers}</div>
        <div className="text-xs text-muted-foreground mt-1">Aktive Benutzer heute</div>
      </div>
    </div>
  );
};

export default ComplianceStats;